const ICONS = {

}

const IMAGES = {
    ARROW: "arrow_up_grey_color.svg",
    EXCEL: 'excel_icon.svg',
}

export {ICONS, IMAGES}
